import {
  Organizacia as OrganizaciaGenerated,
  OrganizaciaListExternalApi,
  OrganizacnaSkupinaEnum,
} from 'ciselniky-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import Organizacia from '../../../model/ciselniky/Organizacia';

const client = new OrganizaciaListExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(organizacie: OrganizaciaGenerated[]): Organizacia[] {
  return organizacie.map(organizacia => ({
    uuid: organizacia.uuid,
    nazov: organizacia.uplnyNazov,
    uplnyNazov: organizacia.skratenyNazov
      ? `${organizacia.skratenyNazov} (${organizacia.uplnyNazov})` : organizacia.uplnyNazov,
    email: organizacia.kontakt.email,
    ldapUuid: organizacia.ldapUuid,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchOrganizacie = async (
  typ?: OrganizacnaSkupinaEnum,
  ids?: string[],
  ldap?: boolean,
  nazov?: string,
  legislativna?: boolean,
  platna?: boolean,
  limit?: number,
  // eslint-disable-next-line default-param-last
  execute = true,
  headers?: object,
):
  Promise<ClientResponse<Organizacia[]>> => {
  if (!execute) {
    return {
      data: [],
      responseCode: null,
    };
  }

  const {
    data,
    status,
  } = await client.getOrganizaciaList(typ, ids, ldap, nazov, legislativna, platna, limit, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
